import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory, useLocation } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import Select from 'react-select';
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert'
import { searchOutline, chevronDownOutline, create } from "ionicons/icons";
import ActivityCreateProject from "../../Team Member/ActivityCreateProject"

const HRProject: React.FC = () => {
    const history = useHistory();
    const location: any = useLocation()
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
            if (location.state) {
                console.log(location)
                setId(location.state.projectId)

            }

        }
    }, [token, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");
    const [businessUnitArr, setBusinessUnitArr]: any = useState([]);

    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [modalopen2, setModalopen2] = useState(false);

    const [modalopen3, setModalopen3] = useState(false);
    const [currentProjectStatus, setCurrentProjectStatus] = useState("");
    const [id, setId] = useState("");

    const [clientName, setClientName] = useState("");
    const [clientView, setClientView] = useState([]);

    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [updatedBy] = useState(localStorage.getItem("SignupEmpId"));
    const [loading, setloading] = useState(false)
    const [bussinessUnitArr, setBussinessUnitArr] = useState([]);
    const [bussinessUnitArr1, setBussinessUnitArr1]: any = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [projectManagerArr, setProjectManagerArr] = useState([]);
    const [projectmanager, setprojectmanager] = useState('')
    const [isEdit, setIsEdit] = useState(true);

    /*........Create.......... */
    const [projectName, setProjectName] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setTodate] = useState("");
    const [description, setDescription] = useState("");
    const [bussinessUnit, setBussinessUnit] = useState("");
    const [departmentUnit, setDepartmentUnit] = useState("");
    const [projectManager, setProjectManager] = useState("")

    /*......... VIew & Update .......... */
    const [pname, setPname] = useState("");
    const [cname, setCname] = useState("");
    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [desc, setDeasc] = useState("");
    const [closeddate, setcloseddate] = useState("");
    const [closedby, setclosedby] = useState("");
    const [assignedResources, setAssignedResources] = useState([]);
    const [updateBussinessUnit, setUpdateBussinessUnit] = useState("");
    const [updateDepartmentUnit, setUpdateDepartmentUnit] = useState("");
    const [updateProjectManager, setUpdateProjectManager] = useState("")
    const [employeeId, setemployeeId] = useState('')
    const [employee, setemployee] = useState('')

    /*............ Assign Project............... */
    const inputArr1 = [
        {
            employeeId: "",
            projectId: "",
            assignedBy: "",
            responsibilities: "",
            businessUnitId: ""
        }
    ];

    const [project, setProject] = useState(inputArr1)
    const [assigntable, setAssigntable] = useState([]);
    const [prjName, setPrjName] = useState("");
    const [projectId, setProjectId] = useState("");

    const [nameView, setNameView]: any = useState([0]);

    const [assign]: any = useState(localStorage.getItem("SignupEmpId"));
    // const [ProjectId]: any = useState(localStorage.getItem("Project"));
    const [assignId, setAssignId]: any = useState([]);

    /*.............. Activity Code ........... */

    const inputArr = [
        {
            activityCode: "",
            activityMeta: "",
            activityDescription: "",
            projectId: "",
            createdBy: "",
            parentActivityId: "",
        }
    ]

    const [activity, setActivity]: any = useState(inputArr)

    const [activityMetaMap, setActivityMetaMap]: any = useState([]);
    const [proId, setProId] = useState("");

    const [activityList, setActivityList] = useState([]);

    const [parentActivityArr, setParentActivityArr] = useState([]);
    const [parentActivity, setParentActivity] = useState("");

    //-----------------Businessunit Autocomplete----------------//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const [statusId, setStatusId] = useState('')
    const [statusList, setStatusList] = useState([]);
    const [projectStatusId, setProjectStatusId] = useState("")
    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };
    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }
    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholders = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Business Unit </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const optionss = bussinessUnitArr1.map((state: any) => ({
        value: state.id,
        label: state.businessUnitName,
    }));

    const handleBusinessChange = (selectedOption1: any) => {
        console.log(selectedOption1.value, "kn");
        setBussinessUnit(selectedOption1.value);
        setUpdateBussinessUnit(selectedOption1.value)
        ViewAllDepartmentunit(selectedOption1.value);
    };

    //-------------------Departmentunit Autocomplete---------------//

    const [selectedOption2, setSelectedOption2] = useState(null);
    const [inputValue2, setInputValue2] = useState('');
    const [isFocused2, setIsFocused2] = useState(false);
    const [menuIsOpen2, setMenuIsOpen2] = useState(false);

    const handleStateChange2 = (selectedOption2: any) => {
        setSelectedOption2(selectedOption2);
    };

    const handleInputChange2 = (inputValue2: any) => {
        setInputValue2(inputValue2);
    };

    const handleMenuOpen2 = () => {
        setMenuIsOpen2(true);
    };

    const handleMenuClose2 = () => {
        setMenuIsOpen2(false);
    };

    const handleFocus2 = () => {
        setIsFocused2(true);
    };

    const handleBlur2 = () => {
        setIsFocused2(false);
    };

    const Placeholder2 = () => {
        if (inputValue2 === '' && !selectedOption2 && !isFocused2) {
            return <span style={{ color: "black" }}>Select Department Unit </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen2) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen2]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const optionsss = departmentUnitArr.map((state: any) => ({
        value: state.id,
        label: state.departmentName,
    }));

    const handleDepartmentChange = (selectedOption2: any) => {
        console.log(selectedOption2.value, "kn");
        setDepartmentUnit(selectedOption2.value);
        setUpdateDepartmentUnit(selectedOption2.value)
    };

    //-------------Project Manager Autocomplete-------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Project Manager </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = projectManagerArr.map((state: any) => ({
        value: state.id,
        label: state.name,
    }));
    const handleprojectUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setProjectManager(selectedOption.value);
        setUpdateProjectManager(selectedOption.value)
    };

    //---------------Client Autocomplete-------------------//

    const [selectedOption3, setSelectedOption3] = useState(null);
    const [inputValue3, setInputValue3] = useState('');
    const [isFocused3, setIsFocused3] = useState(false);
    const [menuIsOpen3, setMenuIsOpen3] = useState(false);

    const handleStateChange3 = (selectedOption3: any) => {
        setSelectedOption3(selectedOption3);
    };

    const handleInputChange3 = (inputValue3: any) => {
        setInputValue3(inputValue3);
    };

    const handleMenuOpen3 = () => {
        setMenuIsOpen3(true);
    };

    const handleMenuClose3 = () => {
        setMenuIsOpen3(false);
    };

    const handleFocus3 = () => {
        setIsFocused3(true);
    };

    const handleBlur3 = () => {
        setIsFocused3(false);
    };

    const Placeholder3 = () => {
        if (inputValue3 === '' && !selectedOption3 && !isFocused3) {
            return <span style={{ color: "black" }}>Select Client  </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator3: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen3) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen3]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const Clientoptions = clientView.map((state: any) => ({
        value: state.id,
        label: state.name,
    }));

    const handleClientChange = (selectedOption3: any) => {
        console.log(selectedOption3.value, "kn");
        setCname(selectedOption3.value);
    };

    //---------Clientupdate Autocomplete-----------//

    const handleClientupdateChange = (selectedOption3: any) => {
        console.log(selectedOption3.value, "kn");
        setClientName(selectedOption3.value);
    };

    //------------Employee Autocomplete-----------------//

    const [selectedOption5, setSelectedOption5] = useState(null);
    const [inputValue5, setInputValue5] = useState('');
    const [isFocused5, setIsFocused5] = useState(false);
    const [menuIsOpen5, setMenuIsOpen5] = useState(false);

    const handleStateChange5 = (selectedOption5: any) => {
        setSelectedOption5(selectedOption5);
    };

    const handleInputChange5 = (inputValue5: any) => {
        setInputValue5(inputValue5);
    };

    const handleMenuOpen5 = (index: any) => {
        setMenuIsOpen5(index);
    };

    const handleMenuClose5 = () => {
        setMenuIsOpen5(false);
    };

    const handleFocus5 = () => {
        setIsFocused5(true);
    };

    const handleBlur5 = () => {
        setIsFocused5(false);
    };
    const Placeholder5 = () => {
        if (inputValue5 === '' && !selectedOption5 && !isFocused5) {
            return <span style={{ color: "black" }}>Select Employee </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator5: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    //------------------Businessunit Autocomplete--------------------//

    const [selectedOption6, setSelectedOption6] = useState(null);
    const [inputValue6, setInputValue6] = useState('');
    const [isFocused6, setIsFocused6] = useState(false);
    const [menuIsOpen6, setMenuIsOpen6] = useState(false);

    const handleStateChange6 = (selectedOption6: any) => {
        setSelectedOption6(selectedOption6);
    };

    const handleInputChange6 = (inputValue6: any) => {
        setInputValue6(inputValue6);
    };

    const handleMenuOpen6 = (index: any) => {
        setMenuIsOpen6(index);
    };

    const handleMenuClose6 = () => {
        setMenuIsOpen6(false);
    };

    const handleFocus6 = () => {
        setIsFocused6(true);
    };

    const handleBlur6 = () => {
        setIsFocused6(false);
    };
    const Placeholder6 = () => {
        if (inputValue6 === '' && !selectedOption6 && !isFocused6) {
            return <span style={{ color: "black" }}>Select Business unit </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator6: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    //----------------Parent Activity-----------------//

    const [selectedOption7, setSelectedOption7] = useState(null);
    const [inputValue7, setInputValue7] = useState('');
    const [isFocused7, setIsFocused7] = useState(false);
    const [menuIsOpen7, setMenuIsOpen7] = useState(false);

    const handleStateChange7 = (selectedOption7: any) => {
        setSelectedOption7(selectedOption7);
    };

    const handleInputChange7 = (inputValue7: any) => {
        setInputValue7(inputValue7);
    };

    const handleMenuOpen7 = (index: any) => {
        setMenuIsOpen7(index);
    };

    const handleMenuClose7 = () => {
        setMenuIsOpen7(false);
    };

    const handleFocus7 = () => {
        setIsFocused7(true);
    };

    const handleBlur7 = () => {
        setIsFocused7(false);
    };
    const Placeholder7 = () => {
        if (inputValue7 === '' && !selectedOption7 && !isFocused7) {
            return <span style={{ color: "black" }}>Select Parent Activity </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator7: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options5 = [

        ...parentActivityArr.map((state: any) => ({
            value: state.id,
            label: state.parentActivity,
        })),
    ];

    //---------------------Activity meta Autocomplete-------------//

    const [selectedOption8, setSelectedOption8] = useState(null);
    const [inputValue8, setInputValue8] = useState('');
    const [isFocused8, setIsFocused8] = useState(false);
    const [menuIsOpen8, setMenuIsOpen8] = useState(false);

    const handleStateChange8 = (selectedOption8: any) => {
        setSelectedOption8(selectedOption8);
    };

    const handleInputChange8 = (inputValue8: any) => {
        setInputValue8(inputValue8);
    };

    const handleMenuOpen8 = (index: any) => {
        setMenuIsOpen8(index);
    };

    const handleMenuClose8 = () => {
        setMenuIsOpen8(false);
    };

    const handleFocus8 = () => {
        setIsFocused8(true);
    };

    const handleBlur8 = () => {
        setIsFocused8(false);
    };
    const Placeholder8 = () => {
        if (inputValue8 === '' && !selectedOption8 && !isFocused8) {
            return <span style={{ color: "black" }}>Select Activity Meta </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator8: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    //.................Project Status........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Open</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options9 = statusList.map((state: any) => ({
        value: state.id,
        label: state.status,
    }));

    const hanldeStatusTypes = (selectedOption9: any) => {
        setProjectStatusId(selectedOption9.value)
    }
    //-----------------Navigate if we click yes------------//

    const View = (assign: any) => {
        console.log(assign, "signupid");
        history.push({ pathname: "/ActivityCreateProject", state: { Id: assign } });
    };

    //-----------------Navigate if we click No------------//

    const ViewGeneral = (projectId: any) => {
        history.push({ pathname: "/GendralActivityAssign", state: { proId: projectId } });
    }

    //----------------Getall Projects Datatable---------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "83px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NA';
                }
            },

            sortable: true,
            sort: "businessUnitName",
            width: "143px"
        },
        {
            name: "Department",
            // selector: (itm: any) => itm.masterDepartment.departmentName,
            selector: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NA';
                }
            },
            sortable: true,
            sort: "departmentName",
            width: "180px"
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,
            width: "200px"
        },
        {
            name: "Created Date",
            selector: (itm: any) => itm.createdDate,
            sortable: true,
            sort: "createdDate",
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            },
            width: "145px"
        },
        {
            name: "Created By",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
            width: "150px"

        },
        {
            name: "Resources",
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
            width: "121px"
        },
        {
            name: "Status",
            // selector: (itm: any) => itm.projectStatus.status,
            sortable: true,
            width: "94px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.projectStatus.status === "Open" ? (
                        <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                    ) : itm.projectStatus.status === "Hold" ? (
                        <p style={{ color: "orange", margin: '0' }}>Hold</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>Close</p>
                    )}
                </div>

            )
        },
        {
            name: "Assign Resources",
            sortable: false,
            width: "160px",
            cell: (itm: any) => (
                <div>
                    <IonText style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }} onClick={() => openmodal2(itm, itm.id)} >Manage Resources</IonText>
                </div>
            )
        },
        {
            name: "View",
            sortable: false,
            width: "68px",
            cell: (itm: any) => (
                <div>
                    <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }}>View</IonText>
                </div>
            )

        },

        {
            name: "Assign Activity",
            sortable: false,
            cell: (itm: any) => (
                <div>
                    <IonText onClick={() => openmodal3(itm, itm.id)} style={{ color: "coral", cursor: 'pointer', fontSize: '14px', padding: "2px" }}>Assign Activity</IonText>
                </div>
            ),
            // width: "150px"
        }
    ];

    //-----------------ManageResouces Datatable------------//

    const Assigncolumn: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
            width: "67px"
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.employee,
            sortable: true,
            width: "250px"
        },
        {
            name: "Assigned Date",
            sortable: true,
            selector: (itm: any) => moment(itm.assignedDate).format("DD-MM-YYYY"),
            width: "180px"
        },
        {
            name: "Assigned By",
            selector: (itm: any) => itm.assignedBy,
            sortable: true,
            width: "180px"
        },
        {
            name: "Remove",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                        <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => Removedata(itm.employeeId, itm.projectId)}>Remove</IonText>
                    </div>
                </>
            )
        },
    ]

    //--------------Assign Activity Datatable--------------//

    const ActivityListColumn: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
            width: "67px"
        },
        {
            name: "Activity Meta",
            selector: (itm: any) => itm.activityMeta,
            sortable: true,
            width: "350px"
        },
        {
            name: "Activity Code",
            sortable: true,
            selector: (itm: any) => itm.activityCode,
            width: "300px"
        },
        {
            name: "Activity Description",
            selector: (itm: any) => itm.activityDescription,
            sortable: true,
        },
    ]


    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };
    //---------------Search filter---------------//

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //---------------Getall Api------------------//    

    useEffect(() => {
        var role = localStorage.getItem("UserRole")
        console.log(role, "kmk")
        if (role === "MANAGER" || role === "Manager") {
            setIsEdit(false)
        }
        else {
            setIsEdit(true)
        }
        AllClients();
        LoadProject();
        ViewProjectManagerList();
        ViewAllBusinessunitDropDown();
        GetStatusList();
    }, [])

    // const LoadProject = () => {
    //     setloading(true);
    //     service.GetallProject(createdBy, projectStatusId)
    //         .then((response) => {
    //             console.log(response);
    //             if (response.data.status === "400") {
    //                 setData([]);
    //             } else {
    //                 setData(response.data.Data);
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         })
    //         .finally(() => {

    //             setTimeout(() => {
    //                 setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
    //             }, 500); // Adjust the timeout duration as needed
    //         });
    // };
    const LoadProject = () => {
        setloading(true)
        service.GetallProject(createdBy, projectStatusId)
            .then((response) => {
                console.log(response);
                if (response.data.status === "400") {
                    setData([]);
                }
                else {
                    setData(response.data.Data)
                }
            })
            .catch((error) => {
                console.log(error);
            })

            .finally(() => {

                setTimeout(() => {
                    setloading(false);
                }, 500);
            });
    }
    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }
    //--------------Clients Dropdown Api-----------------//

    const AllClients = () => {
        service.GetAllClientNameDropDown()
            .then((response) => {
                console.log("All Client")
                console.log(response);
                if (response.data.status === "200") {
                    setClientView(response.data.data)
                    setCname(cname)

                }
                else {
                    setClientView([])
                }
            })
    }

    //--------------Employee Name Dropdown Api--------------//

    const ProjectManagerView = (Id: any) => {
        service.GetAllEmployeeNames(Id, createdBy)
            .then((response) => {
                console.log("All Employee Names")
                console.log(response)
                if (response.data.status === "200") {
                    // setNameView(response.data.data)
                    setProjectManagerArr(response.data.data)

                }
                else {
                    // setNameView([])
                    setProjectManagerArr([])
                }
            })
    }

    //-----------------Remove Data Api-----------------//

    const Removedata = (employeeId: any, projectId: any) => {
        swal({
            title: 'Are you sure?',
            text: 'You want to Remove ',
            icon: 'warning',
            buttons: ['NO', 'YES'],
        }).then((confirmed) => {
            if (confirmed) {
                console.log('Confirmed');
                service.Remove(employeeId, projectId)
                    .then((response) => {
                        console.log(response);
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                console.log('Cancelled');
            }
        });
    };

    //--------------------Businessunit Dropdown Api-----------------//

    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                console.log(id)
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
                    // setBusinessUnitArr((prevActivityMap: any) => {
                    //     const updatedActivityMap: any = { ...prevActivityMap };
                    //     updatedActivityMap[j] = response.data.Data;
                    //     return updatedActivityMap;
                    // });
                } else {
                    setBusinessUnitArr([])
                    // setBusinessUnitArr((prevActivityMap: any) => {
                    //     const updatedActivityMap: any = { ...prevActivityMap };
                    //     updatedActivityMap[j] = [];
                    //     return updatedActivityMap;
                    // });
                }
            })
    }

    const ViewAllBusinessunitDropDown = () => {
        service.GetDropDownBusinessUnitOnProject(createdBy)
            .then((response) => {
                console.log("Bussiness Unit", business)
                console.log(response);

                if (response.data.Status === "200") {
                    setBussinessUnitArr1(response.data.Data)

                }
                else {
                    setBussinessUnitArr1([])
                }
            })
    }
    // const sortemp = () => {
    //     service.GetAllEmployeeFilterByBu(business, projectId)
    //         .then((response) => {
    //             console.log("Employee")
    //             console.log(response);
    //             if (response.data.Status === "200") {
    //                 setData(response.data.Data)
    //             } else {
    //                 alert('cds')
    //             }
    //         })
    // }
    // const ViewAllDepartmentunit1 = () => {
    //     service.GetAllDepartmentUnitDropDown(business)
    //         .then((response) => {
    //             console.log("Department Unit")
    //             console.log(response);
    //             if (response.data.Status === "200") {
    //                 setDepartmentUnitArr(response.data.Data)
    //             } else {
    //                 setDepartmentUnitArr([])
    //             }
    //         })
    // }

    //-----------------Departmentunit Dropdown Api-------------------//

    const ViewAllDepartmentunit = (id: any) => {
        setDepartmentUnit("");
        console.log(id, "lmlm")
        var user = localStorage.getItem("UserRole")
        if (user != "DEPARTMENT_HEAD") {
            service.GetAllDepartmentUnitDropDown(id)
                .then((response) => {
                    console.log("Department Unit")
                    console.log(response);
                    if (response.data.Status === "200") {
                        setDepartmentUnitArr(response.data.Data)
                    } else {
                        setDepartmentUnitArr([])
                    }
                })
        }
        else {
            service.GetAllDepartmentUnitDropDownOnProject(id, assign)
                .then((response) => {
                    console.log("Department Unit")
                    console.log(response);
                    if (response.data.Status === "200") {
                        setDepartmentUnitArr(response.data.Data)
                    } else {
                        setDepartmentUnitArr([])
                    }
                })
        }
    }

    //---------------------EmployeeList Dropdown-------------------//

    const ViewProjectManagerList = () => {
        service.GetAllEmployeeNameDropDown()
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data === null || response.data.Data === null) {
                    setProjectManagerArr([])
                }
                else {
                    setProjectManagerArr(response.data.Data);
                }
            })
    }

    // const handleClient = (e: any) => {
    //     setClientName(e.target.value)
    // }

    // const handleUpdateBussinessUnit = (e: any) => {
    //     setUpdateBussinessUnit(e.target.value)
    //     ViewAllDepartmentunit(e.target.value)
    // }

    // const handleUpdateDepartmentUnit = (e: any) => {
    //     setUpdateDepartmentUnit(e.target.value)
    // }

    // const handleUpdateProjectManager = (e: any) => {
    //     setUpdateProjectManager(e.target.value)
    // }

    // const handleCreateClient = (e: any) => {
    //     setCname(e.target.value);
    // }

    // const handleCreateBussinessUnit = (e: any) => {
    //     setBussinessUnit(e.target.value)
    //     ViewAllDepartmentunit(e.target.value)
    // }

    // const handleCreateDepartmentUnit = (e: any) => {
    //     setDepartmentUnit(e.target.value)
    // }

    // const handleCreateProjectManager = (e: any) => {
    //     setProjectManager(e.target.value)
    // }

    //.........................Project Datatable.............................//

    const openmodal = (id: any) => {
        setId(id)
        setModalopen(true);
        service.GetProjectById(id)
            .then((response) => {
                if (response.status == 200) {
                    console.log(response.data);
                    //   const projectData = response.data.Data[0];
                    if (response.data.data.projectName === null || response.data.data.projectName === "") {
                        setPname("")
                    }
                    else {
                        setPname(response.data.data.projectName)
                    }
                    if (response.data.data.client.id === null || response.data.data.client.id === "") {
                        setCname("")
                    }
                    else {
                        setCname(response.data.data.client.id)
                    }
                    if (response.data.data.fromDate === null || response.data.data.fromDate === "") {
                        setFDate("")
                    }
                    else {
                        setFDate(response.data.data.fromDate)
                    }
                    if (response.data.data.toDate === null || response.data.data.toDate === "") {
                        setTDate("")
                    }
                    else {
                        setTDate(response.data.data.toDate)
                    }
                    if (response.data.data.businessUnitId === null || response.data.data.businessUnitId === "") {
                        setUpdateBussinessUnit("")
                    }
                    else {
                        setUpdateBussinessUnit(response.data.data.businessUnitId)
                        ViewAllDepartmentunit(response.data.data.businessUnitId)
                    }
                    if (response.data.data.masterDepartmentId === null || response.data.data.masterDepartmentId === "") {
                        setUpdateDepartmentUnit("")
                    }
                    else {
                        setUpdateDepartmentUnit(response.data.data.masterDepartmentId)
                    }
                    if (response.data.data.projectManager === null || response.data.data.projectManager === "") {
                        setUpdateProjectManager("")
                    }
                    else {
                        setUpdateProjectManager(response.data.data.projectManager)
                    }
                    if (response.data.data.project_Description === null || response.data.data.project_Description === "") {
                        setDeasc("")
                    }
                    else {
                        setDeasc(response.data.data.project_Description)
                    }
                    if (response.data.data.closedAt === null || response.data.data.closedAt === "") {
                        setcloseddate("")
                    }
                    else {
                        setcloseddate(response.data.data.closedAt)
                    }
                    if (response.data.data.projectStatus && response.data.data.projectStatus.status) {
                        setCurrentProjectStatus(response.data.data.projectStatus.status);
                    }
                    if (response.data.data.closedBy.name === null || response.data.data.closedBy.name === "") {
                        setclosedby("")
                    }
                    else {
                        setclosedby(response.data.data.closedBy.name)
                    }

                    if (response.data.data.assignedResources === null || response.data.data.assignedResources === "") {
                        setAssignedResources([])
                    }
                    else {
                        setAssignedResources(response.data.data.assignedResources)
                    }
                }
            })
    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    //.......................Manage Resouces Datatable..........................//

    const openmodal2 = (itm: any, Id: any) => {
        setModalopen2(true);
        service.GetProjectAssignedListById(Id)
            .then((response) => {
                console.log("Assigned Project List")
                console.log(response);

                if (response.data.status === "200") {
                    setAssigntable(response.data.data)
                    // setemployee(response.data.employee)
                    // for (let i = 0; i < response.data.data.length; i++) {
                    //     assignId.push(response.data.data[i].employeeId)
                    // }
                    // console.log(response.data.data.employeeId,"kmkkkk")
                }
                else {
                    setAssigntable([])
                    // setAssignId([])
                }
            });
        ProjectManagerView(Id);
        setPrjName(itm.projectName)
        setProjectId(itm.id)
        ViewAllBusinessunit();
        // }
    }

    //.........................Assign Activity Datatable...................//

    const openmodal3 = (itm: any, Id: any) => {
        console.log(itm, "km")
        console.log(Id, "Project Id ")
        setProId(Id);
        setModalopen3(true);
        service.GetActivityCodeByProjectId(Id)
            .then((response) => {
                console.log("Activity List")
                console.log(response);
                if (response.data.Status === "405") {
                    setActivityList([]);
                }
                else {
                    setActivityList(response.data.data)
                }
            });
        service.GetAllParentActivity()
            .then((response) => {
                console.log("Parent Activity")
                console.log(response);
                if (response.data.Status === 200 || response.data.Status === "200") {
                    setParentActivityArr(response.data.Data)
                }
                else {
                    setParentActivityArr([])
                }
            });

        // service.ActivityGetAll()
        //     .then((response) => {
        //         console.log("Activity Meta")
        //         console.log(response);
        //         if (response.data.Status === 200 || response.data.Status === "200") {
        //             setActivityMetaMap(response.data.Data)
        //         }
        //         else {
        //             setActivityMetaMap([])
        //         }
        //     });
    }

    const closemodal = () => {
        setModalopen(false);
        setCname("");
        setPname("");
        setFDate("");
        setTDate("");
        setDeasc("");
        setUpdateBussinessUnit("");
        setUpdateDepartmentUnit("");
        setUpdateProjectManager("");
        setAssignedResources([]);
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setClientName("");
        setProjectName("");
        setFromDate("");
        setTodate("");
        setDescription("");
        setBussinessUnit("");
        setDepartmentUnit("");
        setProjectManager("");
    }

    const closemodal2 = () => {
        setModalopen2(false);
        setProject(inputArr1)
    }

    const closemodal3 = () => {
        setModalopen3(false);
        setActivity(inputArr);
        setAssigntable([]);
        // setAssignId([]);
    }

    //...................Project Create Api....................//

    const Create = () => {
        if (projectName === "") {
            swal("", "Please Enter Project Name", "info");
        } else if (clientName === "") {
            swal("", "Please Select Client", "info");
        } else if (fromDate === "") {
            swal("", "Please Enter From Date", "info");
        } else if (toDate === "") {
            swal("", "Please Enter To Date", "info");
        } else if (departmentUnit === "") {
            swal("", "Please Select Department Unit", "info");
        } else if (description === "") {
            swal("", "Please Enter Project Description", "info");
        } else if (projectManager === "") {
            swal("", "Please Select Project Manager", "info");
        } else {
            service
                .CreateProject(
                    projectName,
                    fromDate,
                    toDate,
                    description,
                    clientName,
                    createdBy,
                    bussinessUnit,
                    departmentUnit,
                    projectManager
                )
                .then((response) => {
                    console.log(response);
                    if (response.data.status === "200") {
                        setId(response.data.Data.id)
                        swal({
                            title: "Project Created Successfully",
                            text: "Do you want to inherit Activity Codes from other existing projects?",
                            icon: "success",
                            buttons: {
                                yes: {
                                    text: "Yes",
                                    value: "yes",
                                },
                                no: {
                                    text: "No",
                                    value: "no",
                                },
                            },
                        }).then((value) => {
                            if (value === "yes") {
                                console.log(assign);
                                View(assign);
                            } else if (value === "no") {
                                ViewGeneral(response.data.Data.id);
                            }
                        });
                    } else {
                        swal("", "Not Created", "error");
                    }
                });
        }
    };

    //........................Update Project Api....................//

    const Update = () => {
        if (cname.length === 0) {
            swal("", "Please Select Client Name", "info");
            return;
        }
        else if (pname.length === 0) {
            swal("", "Please Enter Project Name", "info");
            return;
        }
        else if (fDate === "") {
            swal("", "Please Enter From Date", "info");
            return;
        }
        else if (tDate === "") {
            swal("", "Please Enter To Date", "info");
            return;
        }
        else if (updateBussinessUnit === "") {
            swal("", "Please Select Bussiness Unit", "info");
        }
        else if (updateDepartmentUnit === "") {
            swal("", "Please Select Department Unit", "info");
        }
        else if (updateProjectManager === "") {
            swal("", "Please Select Project Manager", "info");
        }
        else if (desc.length === 0) {
            swal("", "Please Enter Project Description Name", "info");
            return;
        }
        else {
            service.UpdateProject(id, pname, cname, fDate, tDate, desc, updatedBy, updateBussinessUnit, updateDepartmentUnit, updateProjectManager)
                .then((response) => {
                    if (response.data.status === "200") {
                        console.log("RESPONSE", response);
                        swal("", "Updated Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", "Not Updated", "error");
                        window.location.reload();
                        console.log(response);
                    }
                });
        }
    }

    //.........................Create Businessunit Dropdown...........................//

    const handleBusinessUnitChange = (selectedOption: any, j: any, i: number) => {
        project[j].businessUnitId = selectedOption.value;
        const selectedBusinessUnitId = selectedOption.value;
        project[j].businessUnitId = selectedBusinessUnitId;
        // setBusiness(e.target.value)
        // ViewAllBusinessunitDropDown();
        service.GetAllEmployeeFilterByBu(selectedOption.value, projectId)
            .then((response) => {
                console.log("Employee")
                console.log(response);
                if (response.status === 200) {
                    setNameView((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[j] = response.data;
                        return updatedActivityMap;
                    });
                } else {
                    setNameView((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[j] = [];
                        return updatedActivityMap;
                    });
                }
            })
    }

    //..................Manage Resouces Create Api...................//

    const CreateAssignedResource = () => {
        var employeeId;
        var responsibilities;
        for (let i = 0; i < project.length; i++) {
            if (project[i].employeeId === "") {
                employeeId = "";
            }
            if (project[i].responsibilities === "") {
                responsibilities = "";
            }
        }

        if (employeeId === "") {
            swal("", "Please Select Employee ", "info");
        }
        else if (responsibilities === "") {
            swal("", "Please Enter Responsibilities ", "info");
        }
        else {
            service.AssignProjectResource(project)
                .then((response) => {
                    if (response.data.status === '200') {
                        swal("", "Assigned Successfully", "success");
                        window.location.reload()
                    }
                    else {
                        swal("", response.data.message, "info");
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }

    //...................Activity Create Api..................//

    const CreateActivity = () => {
        var activityMeta;
        var activityCode;
        var activityDescription;
        for (let i = 0; i < activity.length; i++) {
            if (activity[i].activityMeta === "") {
                activityMeta = ""
            }
            if (activity[i].activityCode === "") {
                activityCode = ""
            }
            if (activity[i].activityDescription === "") {
                activityDescription = ""
            }
        }

        if (activityMeta === "") {
            swal("", "Please Select Activity Meta", "info");
        }
        else if (activityCode === "") {
            swal("", "Please Enter Activity Code", "info");
        }
        else if (activityDescription === "") {
            swal("", "Please Enter Activity Description", "info");
        }
        else {
            service.ActivitySaveOrUpdate(activity)
                .then((response: any) => {
                    console.log(response)
                    if (response.data.status === "200") {
                        swal("", response.data.message, "success");
                        window.location.reload()
                    }
                    else {
                        let err = response.data.Error
                        for (let i = 0; i <= err.length; i++) {
                            swal(response.data.message, response.data.Error[i], "info");
                            return;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }

    //.................Morethan One Activity Create....................//
    const isFoundActivity = (val: any) => {
        return activity.some((item: any) => (val === item.activityCode || val === item.activityMeta || val === item.activityDescription || val === item.projectId || val === item.createdBy));
    }

    const addmoreActivity = () => {
        var valSet = isFoundActivity('');
        if (!valSet) {
            setActivity([...activity, { activityCode: "", activityMeta: "", activityDescription: "", projectId: "", createdBy: "" }]);
            return
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }


    //..................Remove Activity.....................//

    const RemoveActivity = (item: any) => {
        const rows = [...activity]
        var index = activity.indexOf(item)

        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setActivity(rows);
    }

    //...................Parent Activity Addmore.....................//

    const handleParentActivity = (selectedOption: any, i: any) => {
        // Update the parentActivityId with the selected value
        activity[i].parentActivityId = selectedOption.value;

        service.GetActivityCodeByParentId(selectedOption.value)
            .then((response) => {
                if (response.data.Status === 200) {
                    setActivityMetaMap((prevActivityMap: any) => {
                        return {
                            ...prevActivityMap,
                            [i]: response.data.Data,
                        };
                    });
                } else {
                    setActivityMetaMap((prevActivityMap: any) => {
                        return {
                            ...prevActivityMap,
                            [i]: [],
                        };
                    });
                }
            });

        console.log(activityMetaMap, "knj");
    };

    //........................Activity Meta Addmore(Assign activity)......................//

    const handleActivityMeta = (selectedOption: any, i: any) => {
        console.log(selectedOption.value, "km")
        const updatedActivity = { ...activity[i] };
        var splitValue = (selectedOption.value).split("-")
        updatedActivity.activityDescription = splitValue[1];
        updatedActivity.activityCode = splitValue[0]
        updatedActivity.activityMeta = selectedOption.value
        updatedActivity.projectId = proId
        updatedActivity.createdBy = createdBy

        const updatedActivityList = [...activity];
        updatedActivityList[i] = updatedActivity;

        setActivity(updatedActivityList);
    };

    const handleActivityDesscription = (e: any, i: any) => {
        activity[i].activityDescription = e.target.value;
    }

    const handleActivityCode = (e: any, i: any) => {
        activity[i].activityCode = e.target.value;
    }

    //..................Addmore Project(Manage Resources)......................//

    const isFoundProject = (val: any) => {
        return project.some((item: any) => (val === item.employeeId || val === item.projectId || val === item.assignedBy || val === item.responsibilities));
    }
    const addmoreProject = () => {
        var valSet = isFoundProject('');
        if (!valSet) {
            setProject([...project, { employeeId: "", projectId: "", assignedBy: "", responsibilities: "", businessUnitId: "" }]);
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    //...............Remove Resources in manage resources..................//  

    const RemoveProject = (item: any) => {
        const rows = [...project]
        var index = project.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setProject(rows);
    }

    //.................Employee in manage resources.................//

    const handleEmployee = (selectedOption: any, i: any) => {
        const updatedProject = [...project];
        updatedProject[i] = {
            ...updatedProject[i],
            employeeId: selectedOption.value,
            projectId: projectId,
            assignedBy: assign,
            businessUnitId: business
        };
        setProject(updatedProject);
    };

    const handleResponsibilities = (e: any, i: any) => {
        project[i].responsibilities = e.target.value;
    }
    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Project
                                    </h3>
                                </div>
                                {isEdit === true ?
                                    <div className="col-auto float-end ml-auto">
                                        <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Project </a>
                                    </div> : <></>}
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status </label>
                                        <Select
                                            options={options9}

                                            value={options9.find((option: any) => option.value === projectStatusId) || null}
                                            onChange={hanldeStatusTypes}
                                            onInputChange={handleInputChange9}
                                            onMenuOpen={handleMenuOpen9}
                                            onMenuClose={handleMenuClose9}
                                            onFocus={handleFocus9}
                                            onBlur={handleBlur9}
                                            menuIsOpen={menuIsOpen9}
                                            isSearchable
                                            // disabled={isEdit === true ? false : true}
                                            placeholder={<Placeholder9 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator9,
                                            }}
                                            className="custom-select0"
                                        />

                                    </div>

                                </div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                        LoadProject();
                                    }} className="btn btn-orange btn-block w-100"> SEARCH </a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*.....................View Project .................. */}
                <Modal
                    // id="logouts-modal"
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Project</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Name <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={pname} disabled={isEdit === true ? false : true} onIonChange={(e: any) => setPname(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Client Name <span className="text-danger">*</span></label>
                                            <Select
                                                options={Clientoptions}

                                                value={Clientoptions.find((option: any) => option.value === cname) || null}
                                                onChange={handleClientChange}
                                                onInputChange={handleInputChange3}
                                                onMenuOpen={handleMenuOpen3}
                                                onMenuClose={handleMenuClose3}
                                                onFocus={handleFocus3}
                                                onBlur={handleBlur3}
                                                menuIsOpen={menuIsOpen3}
                                                isSearchable
                                                // disabled={isEdit === true ? false : true}
                                                placeholder={<Placeholder3 />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator3,
                                                }}
                                                className="custom-select5"
                                            />
                                            {/* <select disabled={isEdit === true ? false : true} value={cname} className="select" onChange={(e: any) => handleCreateClient(e)}>
                                             <option value="" disabled selected>Select Client</option>
                                             {clientView.map((state: any) => (
                                             <option key={state.id} value={state.id}>
                                            {state.name}
                                           </option>
                                          ))}
                                           </select> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>From Date<span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" disabled={isEdit === true ? false : true} value={fDate} onIonChange={(e: any) => setFDate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>To Date <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" disabled={isEdit === true ? false : true} value={tDate} onIonChange={(e: any) => setTDate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">

                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Bussiness Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionss}
                                                    value={optionss.find((option: any) => option.value === updateBussinessUnit) || null}
                                                    onChange={handleBusinessChange}
                                                    onInputChange={handleInputChange1}
                                                    onMenuOpen={handleMenuOpen1}
                                                    onMenuClose={handleMenuClose1}
                                                    onFocus={handleFocus1}
                                                    onBlur={handleBlur1}
                                                    menuIsOpen={menuIsOpen1}
                                                    isSearchable
                                                    placeholder={<Placeholders />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicators,
                                                    }}
                                                    className="custom-select3"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Department Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionsss}
                                                    value={optionsss.find((option: any) => option.value === updateDepartmentUnit) || null}
                                                    onChange={handleDepartmentChange}
                                                    onInputChange={handleInputChange2}
                                                    onMenuOpen={handleMenuOpen2}
                                                    onMenuClose={handleMenuClose2}
                                                    onFocus={handleFocus2}
                                                    onBlur={handleBlur2}
                                                    menuIsOpen={menuIsOpen2}
                                                    isSearchable
                                                    placeholder={<Placeholder2 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator2,
                                                    }}
                                                    className="custom-select4"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Managers<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === updateProjectManager) || null}
                                                    onChange={handleprojectUnitChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Description <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput disabled={isEdit === true ? false : true} value={desc} onIonChange={(e: any) => setDeasc(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    {currentProjectStatus === "Close" && (
                                        <>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label style={{ fontWeight: "bold" }}>Closed Date</label>
                                                    <div>
                                                        <IonInput
                                                            disabled={true}
                                                        
                                                            value={closeddate}
                                                            className="form-control datetimepicker"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label style={{ fontWeight: "bold" }}>Closed By</label>
                                                    <div>
                                                        <IonInput
                                                            disabled={true}
                                                            value={closedby}
                                                            className="form-control datetimepicker"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className="submit-section">
                                    {isEdit === true ?
                                        <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                        :
                                        <button type="button" className="btn-primary submit-btn" onClick={() => closemodal()}>Back</button>}
                                </div>
                                <div className="form-group" style={{ marginTop: "2%" }}>
                                    <label style={{ fontWeight: "bold" }}>Assigned Resources </label>
                                    <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                        {assignedResources.length > 0 && assignedResources.map((itm: any) => (
                                            <li style={{ paddingLeft: "4px" }}>{itm}</li>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
                {/* ----------Create Project------- */}
                <Modal
                    // id="logouts-modal"
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Create Project</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Project Name <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={projectName} onIonChange={(e: any) => setProjectName(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">

                                            <label style={{ fontWeight: "bold" }}>Client Name<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={Clientoptions}

                                                    value={Clientoptions.find((option: any) => option.value === clientName) || null}
                                                    onChange={handleClientupdateChange}
                                                    onInputChange={handleInputChange3}
                                                    onMenuOpen={handleMenuOpen3}
                                                    onMenuClose={handleMenuClose3}
                                                    onFocus={handleFocus3}
                                                    onBlur={handleBlur3}
                                                    menuIsOpen={menuIsOpen3}
                                                    isSearchable
                                                    // disabled={isEdit === true ? false : true}
                                                    placeholder={<Placeholder3 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator3,
                                                    }}
                                                    className="custom-select5"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">

                                            <label style={{ fontWeight: "bold" }}>From Date <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" value={fromDate} onIonChange={(e: any) => setFromDate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">



                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>To Date <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput type="date" value={toDate} onIonChange={(e: any) => setTodate(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">

                                            <label style={{ fontWeight: "bold" }}>Bussiness Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionss}
                                                    value={optionss.find((option: any) => option.value === bussinessUnit) || null}
                                                    onChange={handleBusinessChange}
                                                    onInputChange={handleInputChange1}
                                                    onMenuOpen={handleMenuOpen1}
                                                    onMenuClose={handleMenuClose1}
                                                    onFocus={handleFocus1}
                                                    onBlur={handleBlur1}
                                                    menuIsOpen={menuIsOpen1}
                                                    isSearchable
                                                    placeholder={<Placeholders />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicators,
                                                    }}
                                                    className="custom-select3"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">

                                            <label style={{ fontWeight: "bold" }}>Department Unit<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={optionsss}
                                                    value={optionsss.find((option: any) => option.value === departmentUnit) || null}
                                                    onChange={handleDepartmentChange}
                                                    onInputChange={handleInputChange2}
                                                    onMenuOpen={handleMenuOpen2}
                                                    onMenuClose={handleMenuClose2}
                                                    onFocus={handleFocus2}
                                                    onBlur={handleBlur2}
                                                    menuIsOpen={menuIsOpen2}
                                                    isSearchable
                                                    placeholder={<Placeholder2 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator2,
                                                    }}
                                                    className="custom-select4"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">

                                        <div className="form-group">


                                            <label style={{ fontWeight: "bold" }}>Project Manager<span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === projectManager) || null}
                                                    onChange={handleprojectUnitChange}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">

                                            <label style={{ fontWeight: "bold" }}>Project Description <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={description} onIonChange={(e: any) => setDescription(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="submit-section">
                                        <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>

                {/* .................... Assign Resource Modal ................. */}

                <Modal
                    show={modalopen2} dialogClassName="my-modal modal-dialog-centered"
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Assign Resources</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal2()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            {project.map((item: any, i: any) => (
                                <form className="addmore">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Project Name <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={prjName} readonly className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Business Unit<span className="text-danger">*</span></label>
                                                <div className="select">
                                                    <Select
                                                        options={businessUnitArr.map((state: any) => ({
                                                            value: state.id,
                                                            label: state.businessUnitName
                                                        }))}
                                                        onChange={(selectedOption: any, j: any) => handleBusinessUnitChange(selectedOption, i, j)}
                                                        onInputChange={handleInputChange6}
                                                        onMenuOpen={() => handleMenuOpen6(i)}
                                                        onMenuClose={handleMenuClose6}
                                                        onFocus={handleFocus6}
                                                        onBlur={handleBlur6}
                                                        menuIsOpen={menuIsOpen6 === i}
                                                        isSearchable
                                                        placeholder={<Placeholder6 />}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator6,
                                                        }}
                                                        className={menuIsOpen6 === i ? "custom-select6" : ""}

                                                    />

                                                    {/* <select className="select" onChange={(e: any) => handleBusinessUnitChange(e, i)}>
                                                        <option value="" disabled selected>Select Business Unit</option>
                                                        {businessUnitArr?.map((state: any) => (
                                                            <option key={state.id} value={state.id}>
                                                                {state.businessUnitName}
                                                            </option>
                                                        ))}
                                                    </select> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>
                                                    Employee Name<span className="text-danger">*</span>
                                                </label>
                                                <div className="select">
                                                    <Select

                                                        options={nameView[i]?.length === 0
                                                            ? [{ value: '', label: 'No Employees available', disabled: true }]
                                                            : [
                                                                // { value: '', label: 'Select Employee', disabled: true },
                                                                ...(nameView[i] || []).map((state: any) => ({
                                                                    value: state.id,
                                                                    label: state.name
                                                                }))
                                                            ]
                                                        }
                                                        onChange={(selectedOption: any) => handleEmployee(selectedOption, i)}
                                                        isSearchable
                                                        onInputChange={handleInputChange5}
                                                        onMenuOpen={() => handleMenuOpen5(i)}
                                                        onMenuClose={handleMenuClose5}
                                                        onFocus={handleFocus5}
                                                        onBlur={handleBlur5}
                                                        menuIsOpen={menuIsOpen5 === i}
                                                        placeholder={<Placeholder5 />}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator5,
                                                        }}
                                                        className={menuIsOpen5 === i ? "custom-select4" : ""}
                                                    />
                                                </div>
                                                {/* <div>
                                                    <select className="select" onChange={(e: any) => handleEmployee(e, i)}>
                                                        {nameView[i]?.length === 0 ? (
                                                            <option value="" disabled selected>
                                                                No Employees available
                                                            </option>
                                                        ) : (
                                                            <>
                                                                <option value="" disabled selected>
                                                                    Select Employee
                                                                </option>
                                                                {(nameView[i] || []).map((state: any) => (
                                                                    <option key={state.id} value={state.id}>
                                                                        {state.name}
                                                                    </option>
                                                                ))}
                                                            </>
                                                        )}
                                                    </select>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Responsibilities <span className="text-danger">*</span></label>
                                                <div>
                                                    <IonInput value={item.responsibilities} onIonChange={(e: any) => handleResponsibilities(e, i)} className="form-control datetimepicker" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div>
                                                {project.length > 1 ?
                                                    <div style={{ marginTop: "25px" }}>
                                                        <button onClick={() => RemoveProject(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                    </div> : <></>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            ))}
                            <div style={{ display: "flex" }}>
                                <button onClick={() => addmoreProject()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                            </div>
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={() => CreateAssignedResource()}>Assign</button>
                            </div>
                            {assigntable.length > 0 ?
                                <div>
                                    <label style={{ fontWeight: "bold" }}>Resources </label>
                                    <DataTable
                                        columns={Assigncolumn}
                                        data={assigntable}
                                        pagination
                                        paginationPerPage={3}
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationRowsPerPageOptions={[3, 6, 9]}
                                        customStyles={customStyles}
                                    />
                                </div> : <> </>}
                        </form>
                    </div>
                </Modal>

                {/*....................Assign Activity .................. */}
                <Modal
                    show={modalopen3} dialogClassName="my-modal modal-dialog-centered"
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Assign Activity</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal3()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {activity.map((item: any, i: any) => (
                            <form className="row addmore">
                                <div className="form-group col-md-3">
                                    <label style={{ fontWeight: "bold" }}>Parent Activity<span className="text-danger">*</span></label>
                                    <Select
                                        options={options5}
                                        onChange={(selectedOption: any) => handleParentActivity(selectedOption, i)}
                                        isSearchable
                                        defaultValue={options5.find((option) => option.value === item.parentActivityId)}
                                        onInputChange={handleInputChange7}
                                        onMenuOpen={() => handleMenuOpen7(i)}
                                        onMenuClose={handleMenuClose7}
                                        onFocus={handleFocus7}
                                        onBlur={handleBlur7}
                                        menuIsOpen={menuIsOpen7 === i}
                                        placeholder={<Placeholder7 />}
                                        components={{
                                            DropdownIndicator: DropdownIndicator7,
                                        }}
                                        className={menuIsOpen7 === i ? "custom-select6" : ""}
                                    />
                                </div>

                                <div className="form-group col-md-3">
                                    <label style={{ fontWeight: "bold" }}>Activity Meta<span className="text-danger">*</span></label>
                                    <Select
                                        // defaultValue={{ value: item.activityMeta, label: item.activityMeta }}
                                        defaultValue={options.find((option) => option.value === item.activityMeta)}
                                        onChange={(selectedOption: any) => handleActivityMeta(selectedOption, i)}
                                        options={activityMetaMap[i]?.map((state: any) => ({
                                            value: state.activityMeta,
                                            label: state.activityMeta,
                                        }))}
                                        onInputChange={handleInputChange8}
                                        onMenuOpen={() => handleMenuOpen8(i)}
                                        onMenuClose={handleMenuClose8}
                                        onFocus={handleFocus8}
                                        onBlur={handleBlur8}
                                        menuIsOpen={menuIsOpen8 === i}
                                        placeholder={<Placeholder8 />}
                                        components={{
                                            DropdownIndicator: DropdownIndicator8,
                                        }}
                                        className={menuIsOpen8 === i ? "custom-select6" : ""}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label style={{ fontWeight: "bold" }}>Activity Code <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={item.activityCode} onIonChange={(e: any) => handleActivityCode(e, i)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group col-md-2">
                                    <label style={{ fontWeight: "bold" }}>Activity Description <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={item.activityDescription} onIonChange={(e: any) => handleActivityDesscription(e, i)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group col-md-1">
                                    {activity.length > 1 ?
                                        <div style={{ marginTop: "25px" }}>
                                            <button onClick={() => RemoveActivity(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                        </div> : <></>}
                                </div>
                            </form>
                        ))}
                        <div style={{ display: "flex" }}>
                            <button onClick={() => addmoreActivity()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                        </div>
                        <div className="submit-section">
                            <button type="button" className="btn-primary submit-btn" onClick={() => CreateActivity()}>Assign</button>
                        </div>
                        {activityList.length > 0 ?
                            <div>
                                <label style={{ fontWeight: "bold" }}>Activity </label>
                                <DataTable
                                    columns={ActivityListColumn}
                                    data={activityList}
                                    pagination
                                    paginationPerPage={3}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[3, 6, 9]}
                                    customStyles={customStyles}
                                />
                            </div> : <> </>}
                    </div>
                    {/* //---------end----- */}
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default HRProject